export { CollectionColor } from "./collection-color";
